import alooParatha from "../assets/images/aloo-paratha.jpg";
import burger from "../assets/images/burger.jpg";
import chickenBiryani from "../assets/images/chicken-biryani.jpg";
import chickenNoodles from "../assets/images/chicken-noodles.jpg";
import dosa from "../assets/images/dosa.jpg";
import gadbad from "../assets/images/gadbad.jpg";
import jalebi from "../assets/images/jalebi.jpg";
import kunafa from "../assets/images/kunafa.jpg";
import pizza from "../assets/images/pizza.jpg";
import puri from "../assets/images/puri.jpg";
import rasmalai from "../assets/images/rasmalai.jpg";
import samosa from "../assets/images/samosa.jpg";
import shawarma from "../assets/images/shawarma.jpg";

const recipes = [
  {
    name: "Aloo Paratha",
    image: alooParatha,
    description: "Stuffed Indian flatbread served hot with butter.",
    price: "₹40"
  },
  {
    name: "Burger",
    image: burger,
    description: "Juicy burger with cheese and fresh vegetables.",
    price: "₹120"
  },
  {
    name: "Chicken Biryani",
    image: chickenBiryani,
    description: "Aromatic basmati rice cooked with spiced chicken.",
    price: "₹250"
  },
  {
    name: "Chicken Noodles",
    image: chickenNoodles,
    description: "Stir-fried noodles with chicken and veggies.",
    price: "₹150"
  },
  {
    name: "Dosa",
    image: dosa,
    description: "Crispy dosa served with chutney and sambar.",
    price: "₹80"
  },
  {
    name: "Gadbad",
    image: gadbad,
    description: "Famous layered ice-cream dessert from Udupi.",
    price: "₹180"
  },
  {
    name: "Jalebi",
    image: jalebi,
    description: "Crispy sweet soaked in sugar syrup.",
    price: "₹60"
  },
  {
    name: "Kunafa",
    image: kunafa,
    description: "Middle Eastern dessert with cheese and syrup.",
    price: "₹300"
  },
  {
    name: "Pizza",
    image: pizza,
    description: "Cheesy pizza with delicious toppings.",
    price: "₹350"
  },
  {
    name: "Puri",
    image: puri,
    description: "Deep-fried Indian bread served with curry.",
    price: "₹50"
  },
  {
    name: "Rasmalai",
    image: rasmalai,
    description: "Soft cottage cheese balls in sweet milk.",
    price: "₹120"
  },
  {
    name: "Samosa",
    image: samosa,
    description: "Crispy snack with spicy potato filling.",
    price: "₹30"
  },
  {
    name: "Shawarma",
    image: shawarma,
    description: "Grilled meat wrap with sauces and veggies.",
    price: "₹200"
  }
];

export default recipes;